import { Box, InputBase, Typography, styled } from "@mui/material";
import "../../theme/muiTypes.d.ts";

export const DateInputContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "error",
})<{ error?: boolean }>(({ theme, error }) => ({
  borderRadius: "8px",
  border: `${error ? "2px" : "1px"} solid ${
    error ? theme.palette.status?.error : theme.palette.border?.medium
  }`,
  backgroundColor: error
    ? theme.palette.background?.red
    : theme.palette.background?.secondary,
  display: "flex",
  height: "48px",
  padding: "0 16px",
  alignItems: "center",
  gap: "10px",
  alignSelf: "stretch",
  cursor: "pointer",
  "&:hover": {
    borderColor: error
      ? theme.palette.status?.error
      : theme.palette.primary?.main,
  },
  "&:focus-within": {
    borderColor: error
      ? theme.palette.status?.error
      : theme.palette.primary?.main,
    outline: "none",
  },
}));

export const DateInputField = styled(InputBase)(({ theme }) => ({
  width: "100%",
  height: "100%",
  "& .MuiInputBase-input": {
    height: "100%!important",
    padding: 0,
    fontSize: "16px",
    color: theme.palette.text?.primary,
    fontFamily: "Nunito, sans-serif",
    cursor: "pointer",
    "&::placeholder": {
      color: theme.palette.text?.secondary,
      opacity: 1,
    },
    "&::-webkit-calendar-picker-indicator": {
      display: "none",
    },
  },
}));

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.text?.secondary,
  fontFamily: "Nunito, sans-serif",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  marginBottom: "2px",
  paddingLeft: "8px",
  display: "block",
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.text?.secondary,
  flexShrink: 0,
  "& svg": {
    width: "20px",
    height: "20px",
  },
}));
